import { PersonModel } from '@bayclubs/court-booking-employee-api';
import { ChangePlayerInputModel } from '../models/change-player-input.model';

export enum PlayersActionTypes {
    LoadPlayer = '[Players] Load action',
    SearchPlayers = '[Players] Search players',
    SelectPlayer = '[Players] Select player action',
    ChangePlayer = '[Players] Change player',
    ChangePlayerSuccess = '[Players] Change player success',
    ClearPlayersFormData = '[Players] Clear players form data',
    AddPlayer = '[Players] Add player',
    ClearPlayers = '[Players] Clear players',
    CheckPlayerRulesMatrix = '[Players] Check player rules matrix'
}

export class LoadPlayerAction {
    static type = PlayersActionTypes.LoadPlayer;
    constructor(public playerInput: ChangePlayerInputModel) {}
}

export class SearchPlayersAction {
    static type = PlayersActionTypes.SearchPlayers;
    constructor(public search: string) {}
}

export class SelectPlayerAction {
    static type = PlayersActionTypes.SelectPlayer;
    constructor(public player: PersonModel) {}
}

export class ChangePlayerAction {
    static type = PlayersActionTypes.ChangePlayer;
    constructor(public courtBookingId: string) {}
}

export class ChangePlayerSuccessAction {
    static type = PlayersActionTypes.ChangePlayerSuccess;
}

export class ClearPlayersFormDataAction {
    static type = PlayersActionTypes.ClearPlayersFormData;
}

export class AddPlayerAction {
    static type = PlayersActionTypes.AddPlayer;
    constructor(public email: string, public phone: string) {}
}

export class ClearPlayersAction {
    static type = PlayersActionTypes.ClearPlayers;
}

export class CheckPlayerRulesMatrixAction {
    static type = PlayersActionTypes.CheckPlayerRulesMatrix;
}
